<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="ded"><span aria-label="page vii" id="page_vii" role="doc-pagebreak">For Mara Anastas, my publisher through my first three series.</span></p>
<p class="ded1">Thank you for taking a chance on me!</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2f47668f